'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if (selector !== '.show-more') {
        $(selector).empty().html($updates.html());
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    let expandedRefinement = [];
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        if ($(this).find('.refinement-expanded').length > 0) {
            expandedRefinement.push($(this).find('.refinement-expanded').parent().attr('id'));
        }
    });

    updateDom($results, '.refinements');
    if (expandedRefinement.length > 0) {
        let expandedRefinementParent;
        expandedRefinement.forEach(function(item) {
            expandedRefinementParent = $('#' + item);
            expandedRefinementParent.find('ul').find('li').removeClass('d-none');
            expandedRefinementParent.find('ul').addClass('refinement-expanded');
            expandedRefinementParent.find('.js-view-all-refinements-btn').addClass('d-none');
        });
    }
    
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.js-product-grid',
        '.show-more',
        '.filter-bar',
        '.breadcrumbs-plp'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update page URL
 * 
 */
function updatePageUrl() {
    let currentActivePageParams;

    if ($(this).find("li.active .view-more-button").length > 0) {
        currentActivePageParams = $(this).find("li.active .view-more-button").attr('href');
    } else {
        currentActivePageParams = $(this).find("li.active .view-more-content-button").attr('href');
    }

    window.history.pushState({}, null, currentActivePageParams);
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $currentelement - the jquery element that has the click event attached
 * @return {undefined}
 */
function focusContentSearchResult($currentelement) {
    $currentelement.closest('.search-nav').siblings().find('.content-grid .content-tile .content-tile-image a').first().focus();
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl;
    if ($element.hasClass('content-search')) {
        showMoreUrl = $element.data('url');
    } else {
        showMoreUrl = $element.attr('data-search-update-url');
    }
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.empty().append( response?.renderedContentSearch || response);
            focusContentSearchResult($element);

            if ($('.pagination-links').length > 0) {
                updatePageUrl.apply($('.pagination-links').find('.show-more .active').closest(".pagination"));
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container-fluid').on('click', 'button.js-filter-results', function () {
            let $refinementBar = $('.refinement-bar');
            $refinementBar.addClass('show');
            $refinementBar.removeAttr('inert');
            $('body').addClass('overflow-hidden');
            $('.modal-background').show();
            $refinementBar.siblings().attr('aria-hidden', true);
            $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
            $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $refinementBar.closest('.container-fluid.search-results').siblings().attr('aria-hidden', true);
            $refinementBar.find('.close').focus()
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('body').on('click', '.modal-background, .refinement-bar button.close, .refinement-bar .js-apply-filter', function () {
            $('.refinement-bar .card').addClass('active');
            $('.refinement-bar').removeClass('show');
            $('.refinement-bar').attr('inert', 'true');
            $('body').removeClass('overflow-hidden');
            $('.modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container-fluid').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.js-product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container-fluid').on('click', '.show-more .view-more-button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var showMoreUrl = $(this).attr('data-search-update-url');
            var currentPageParams = '';
            if (showMoreUrl.includes('&start')) {
                currentPageParams = showMoreUrl.substring(showMoreUrl.indexOf('&start')+1);
            }

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            let currentPageNumber = parseInt($(this).data('page-number'), 10);
            $('.pagination-links').find('.pagination-link').removeAttr('aria-disabled');
            if (currentPageNumber > 1) {
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl,
                        paging:currentPageParams
                    },
                    method: 'GET',
                    success: function (response) {
                        $('.js-product-grid').empty().append(response);
                        updateSortOptions(response);
                        let activepagebutton = $('.pagination-links').find('.show-more .active');
                        updatePageUrl.apply(activepagebutton.closest(".pagination"));
                        if (activepagebutton.length > 0 && parseInt(activepagebutton.data('page-number'), 10) > 1 ) {
                            $('.in-grid').not('.d-none').addClass('d-none');
                            $('.in-grid-2').not('.d-none').addClass('d-none');
                        } else {
                            $('.in-grid').removeClass('d-none');
                            $('.in-grid-2').removeClass('d-none');
                        }

                        $('.pagination-links').find('.pagination-link.disabled').attr('aria-disabled',true);
                        $.spinner().stop();
                        $(window).scrollTop(0);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            } else {
                window.location.href = $(this).attr('href');
            }
            
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('body').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .filter-bar .js-filter-reset-btn, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);

                var searchUrl = $(this).data('href');
                var seoUrl = $(this).data('seo-href') || searchUrl;
                if (seoUrl) {
                    window.history.pushState({}, null, seoUrl);
                }

                var attributeId = '#' + $(this).find('span').last().attr('id');
                var currentRefinementId = '#' + $(this).parents('.refinement').find('.card-body').attr('id');
                $.ajax({
                    url: searchUrl,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: searchUrl
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();

                        let mixedRefinements = $(currentRefinementId)?.find('ul.values')?.find('li button[aria-checked="true"]');
                        if(mixedRefinements.length > 1) {
                            mixedRefinements.attr('aria-checked', 'mixed');
                        } else {
                            mixedRefinements.attr('aria-checked', 'true');
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            }
        );
    },

    viewAllCTA: function () {
        $(document).on('click', '.js-view-all-refinements-btn', function () {
            $(this).siblings('ul').addClass('refinement-expanded');
            $(this).siblings('ul').find('li').removeClass('d-none');
            $(this).siblings('ul').find('li.js-other-refinement-category button').first().attr('tabindex', '-1').focus();
            $(this).addClass('d-none');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container-fluid').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
            focusContentSearchResult($(this));
        });

        // Display the next page of content results from the search
        $('.container-fluid').on('click', '.show-more-content a', function (e) {
            e.preventDefault();
            e.stopPropagation();
            getContent($(this), $('#content-grid'));
        });
    },

    onPopState: function () {
        $(window).on('popstate', function () {
            window.location = window.location.href;
        });
    },

    showFolderTab: function () {
        if ($('.search-results').data('active-folder-tab')) {
            $('.content-search').trigger('click');
        }
    },

    editorialProductSearchResult: function() {  
        $('.js-editorial-product-search-result').on('click', function () {
            const editorialProductSearchResultLink = '#product-search-results'; 
            
            if ($(this).attr('href') === editorialProductSearchResultLink) {
                $('#product-search-results').find('.product-grid-tiles .product-tile a').first().focus();    
            }
        }); 
    },

    focusProductSearchResult: function () {
        $('.nav-link.product-search.active').on('click', function () {
            $(this).closest('.search-nav').siblings().find('.loyalty-points-toggle-section .points-toggle-control-js').focus();
        }); 

        $('.container-fluid').on('shown.bs.tab', '#product-tab', function () {
            $(this).closest('.search-nav').siblings().find('.loyalty-points-toggle-section .points-toggle-control-js').focus();
        }); 
    }
};